import * as yup from 'yup'
import { i18n } from 'src/provider/LocaleProvider'

type ErrorMessage = string

export const validationSchema = yup.object().shape({
    first_name: yup
        .string()
        .required(i18n.t('fields.firstName.required') as ErrorMessage)
        .min(3, i18n.t('fields.firstName.min') as ErrorMessage)
        .max(30, i18n.t('fields.firstName.max') as ErrorMessage),
    last_name: yup
        .string()
        .required(i18n.t('fields.lastName.required') as ErrorMessage)
        .min(3, i18n.t('fields.lastName.min') as ErrorMessage)
        .max(30, i18n.t('fields.lastName.max') as ErrorMessage),
    email: yup
        .string()
        .email(i18n.t('fields.email.invalid') as ErrorMessage)
        .required(i18n.t('fields.email.required') as ErrorMessage),
    phone: yup
        .string()
        .max(10, i18n.t('fields.phone.max') as ErrorMessage)
        .matches(/[0-9]+$/, i18n.t('fields.phone.matches') as ErrorMessage)
        .required(i18n.t('fields.phone.required') as ErrorMessage),

    linkedin: yup
        .string()
        .required(i18n.t('fields.link.required') as ErrorMessage)
        .url(i18n.t('fields.link.url') as ErrorMessage),
    curriculum_name: yup
        .string()
        .required(i18n.t('fields.choose.required') as ErrorMessage),
})
